import React, { useState, useReducer } from 'react'
import { Panel } from 'rsuite'
import TaxSumReportTable from './TaxSumReportTable'
import { doneLoading, startLoading } from '../../utils/loading'

export default function TaxSumReportWidget(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  const handleOnSearchEFilling = async (modelType) => {
    const request = {
      modelType: modelType || 0,
    }
    // console.log('request', request)
    handleSearchEFilling(request)
  }
  const handleSearchEFilling = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      console.log('request', request)
      // const response = await searchInstallment(request, projectCode, periodNumber)
      // console.log('resssss 99999 ', response)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={formSchema.header}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <TaxSumReportTable
          schema={formSchema}
          onSearch={handleOnSearchEFilling}
          onCancel={() => {
            handleSearchEFilling({})
          }}
          data={formSchema?.fileseFillingValues}
          loading={isLoading}
        />
      </Panel>
    </>
  )
}
